module.exports = {
	"dk": {
		"football": {
			"id": "1",
			"teams": [
				"8634",
				"8633",
				"10260",
				"9825",
				"8455",
				"8586",
				"8650",
				"9847",
				"9823",
				"9789",
				"8595",
				"8391"
			],
			"leagues": [
				"42",
				"47",
				"46",
				"85",
				"51",
				"87",
				"54",
				"55",
				"87"
			]
		},
		"ice-hockey": {
			"id": "5",
			"teams": [
				"393",
				"263",
				"274",
				"278",
				"262",
				"379",
				"272"
			],
			"leagues": [
				"24",
				"311",
				"9444"
			]
		},
		"tennis": {
			"id": "2"
		},
		"golf": {
			"id": "3"
		},
		"am-football": {
			"id": "24"
		},
		"baseball": {
			"id": "26"
		},
		"basketball": {
			"id": "23"
		},
		"handball": {
			"id": "20"
		},
		"motorsports": {
			"id": "22"
		}
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/config/sports.json
// module id = 957
// module chunks = 0 1